import React from 'react'
import Chip from 'core-system/Chip'

interface TypePillProps {
  type: 'Program' | 'OneTime'
}

const TypePill = ({ type }: TypePillProps) => {
  return <Chip variant={type === 'Program' ? 'purple' : 'pink'}>{type}</Chip>
}

export default React.memo(TypePill)
